import * as actionTypes from 'modules/serviceHeaders/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = (_, { meta = {} }) => !('hideLoader' in meta) || meta.hideLoader === false;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_SERVICE_HEADER]: isLoading,
  [actionTypes.FETCH_SERVICE_HEADER_SUCCESS]: isEnding,
  [actionTypes.FETCH_SERVICE_HEADER_FAILURE]: isEnding,
});
